function get_closest_array_value(counts, goal) {
    return counts.reduce((prev, curr) => Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
}

$.fn.serializeAll = function () {
    var data = $(this).serializeArray();
    $(':disabled[name]', this).each(function () {
        data.push({name: this.name, value: $(this).val()});
    });
    return data;
};

function newton_to_lbs(newton){
    return (newton * 0.224808943).toFixed(1);
}

function lbs_to_newton(lbs){
    return Math.round(lbs / 0.224808943);
}

function inch_to_mm(inch) {
    return Math.round(inch * 25.4);
}

function mm_to_inch(mm) {
    return (Math.round(mm / 25.4 * 100) / 100).toFixed(2);
}

function flbtoa(input) {
    input = encodeURI(input);
    return btoa(input);
}

function flatob(input) {
    var output = decodeURI(atob(input));

    return output;
}

var startTime, endTime;

function start() {
    startTime = new Date();
}

function end() {
    endTime = new Date();
    var timeDiff = endTime - startTime;
    timeDiff /= 1000;
    var seconds = timeDiff;
    console.log(seconds + " seconds");
}

function get_random_hex_color() {
    let colors = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) {
        color += colors[Math.floor(Math.random() * 16)];
    }

    return color;
}

function find_child_by_name(parent, name) {
    let found = null;
    parent.traverse((child) => {
        if (child.name === name) {
            found = child;
        }
    });
    return found;
}